var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChatflowArrowBack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.52,
    height: 16.652,
    viewBox: "0 0 9.52 16.652",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-back",
    "data-name": "Icon ionic-ios-arrow-back",
    d: "M14.12,14.518l6.3-6.3a1.19,1.19,0,1,0-1.685-1.681L11.6,13.675a1.188,1.188,0,0,0-.035,1.641L18.731,22.5a1.19,1.19,0,1,0,1.685-1.681Z",
    transform: "translate(-11.251 -6.194)",
    fill: "#0d70d1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatflowArrowBack);
export default __webpack_public_path__ + "static/media/Chatflow-arrow-back.6df4bc5383c12e3b4da4f7e47d5e8830.svg";
export { ForwardRef as ReactComponent };